
// Angular
import { Injectable } from '@angular/core';

// Afidium
import { ISummary } from 'libraries/component/search-summary/ISummary';
import { DateRangePipe } from '../../shared/pipes/dateRange/dateRange.pipe';
import { ProcessingSearchParameters, IConfig } from '../../shared/models/ProcessingSearchParameters';
import { PROCESSING_STATUSES } from '../../shared/wordings/processing';
import { PROCESSING_WORDING } from 'libraries/service/processing/processing.service';

@Injectable()
export class ProcessingSummaryService {
    constructor(
        private dateRangePipe: DateRangePipe,
    ) {}

    public createSummary( params: ProcessingSearchParameters , fieldLabels: { [key: string]: string }): ISummary[] {
        const textSummary = ProcessingSearchParameters.STRING_ARRAY_PROPERTIES
            .filter((config) => params[config.name] !== undefined && params[config.name].length > 0)
            .map((config: IConfig) => ({
                field: config.name,
                value: this.translateText(config.name, params[config.name]),
                label: fieldLabels[config.name] || config.name,
            }));

        const dateSummary = ProcessingSearchParameters.DATE_RANGE_PROPERTIES
            .filter((config) => params[config.name] !== undefined
                && (params[config.name].min || params[config.name].max))
            .map((config: IConfig) => ({
                field: config.name,
                value: this.dateRangePipe.transform(params[config.name]),
                label: fieldLabels[config.name],
            }));

        return [...textSummary, ...dateSummary];
    }

    private translateText(fieldName: string, values: string[]): string{
        let translated = values;

        switch(fieldName){
            case 'status':
                translated = values.map( ( valueItem: string ) => this.getStatusLabel( valueItem ) );
                break;
            case 'type':
                translated = values.map( ( valueItem: string ) => this.getTypeLabel( valueItem ) );
                break;
        }

        return translated.join(', ');
    }

    private getStatusLabel(status: string): string{
        return PROCESSING_STATUSES[status] || status;
    }

    private getTypeLabel(type: string): string{
        return PROCESSING_WORDING[type] || type;
    }
}
